
import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";
import _ from "@/boot/lodash";

// Components
import SelectMappingProvider from "@/components/app/admin/imports/selectMappingProvider.vue";
import SelectMappingListing from "@/components/app/admin/imports/selectMappingListing.vue";

// Enums/data
import { ImportMappingSource } from "@/data/imports/mappingSources/index";

// Types
import { IImportMapping } from "@/models/imports";

@Component
export default class SelectMappingRender extends Vue {
  // Props

  @Prop({ required: true })
  public mapping!: IImportMapping;

  // Methods

  public itemLinkClicked() {
    this.$emit("close");
  }

  // Computed

  public get mappingSource() {
    return ImportMappingSource(this.mapping.object_type);
  }

  public get showMedia() {
    return !_.isNull(this.mappingSource.render.media);
  }

  public get showSelectMapping() {
    return !_.isEmpty(this.mappingSource);
  }

  // Render functions

  public render(h: CreateElement) {
    if (!this.showSelectMapping) return;

    return h(
      SelectMappingProvider,
      {
        props: this.mappingSource.props,
        attrs: {
          ignoreHistory: true,
          handleLoading: false
        }
      },
      [
        h(
          SelectMappingListing,
          {
            props: {
              selectedId: this.mapping.object_id,
              showMedia: this.showMedia
            },
            on: {
              select: value => this.$emit("select", value)
            },
            scopedSlots: {
              firstLabel: ({ item }) =>
                this.mappingSource.render.firstLabel(
                  h,
                  item,
                  this.itemLinkClicked
                ),
              secondLabel: ({ item }) => {
                return _.isNull(this.mappingSource.render.secondLabel)
                  ? ""
                  : this.mappingSource.render.secondLabel(h, item);
              },
              media: ({ item }) => {
                return _.isNull(this.mappingSource.render.media)
                  ? ""
                  : this.mappingSource.render.media(h, item);
              }
            }
          },
          []
        )
      ]
    );
  }
}
